export default function updateApprovalsPendingCount(count) {
    return {
        type: updateApprovalsPendingCount.type,
        payload: count,
    };
}

updateApprovalsPendingCount.type = 'UPDATE_APPROVALS_PENDING_COUNT';
